export default __webpack_public_path__ + "static/media/step-5.086c3de2.jpeg";